const PATHFINDER_BASE_URL = "https://www.pathfindercard.com/";

type PathfinderPlacement = "banner" | "dashboard_tile";

const UTM_SOURCE = "outschool";
const UTM_MEDIUM = "partner";
const UTM_CAMPAIGN = "learn_more";

export function getPathfinderUrl(placement: PathfinderPlacement): string {
  return `${PATHFINDER_BASE_URL}?utm_source=${UTM_SOURCE}&utm_medium=${UTM_MEDIUM}&utm_campaign=${UTM_CAMPAIGN}&utm_content=${placement}`;
}
